<main class="mat-body">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1
                            class="text-blue mat-display-1 font-weight-bold mb-0"
                            [innerHTML]="'test.result.suitability.title'|translate"
                        ></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-test-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1 mb-0" />
            </div>
        </div>
    </div>

    <div class="bg-blue-gradient">
        <i class="icon-bar-ups d-none d-md-block"></i>
        <i class="icon-mountain d-none d-md-block"></i>

        <div class="container">
            <div class="row justify-content-center text-blue">
                <div class="col-12 col-md-8 text-center my-5">
                    <strong>{{ 'test.result.suitability.knowles-level'|translate }}:</strong>
                </div>
                <div class="col-12 col-md-9" *ngIf="profileName">
                    <thr-certificate [title]="'test.result.investor-profile'" [experience]="profileName"></thr-certificate>
                </div>
                <div class="col-12 col-md-10 text-center my-5">
                    <h3 class="mat-headline my-4">
                        <strong>{{ "test.result.suitability.profile-level"|translate:{profileName: profileName} }}</strong>
                    </h3>
                </div>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row justify-content-end mt-5 mb-4">
            <div class="col-12 col-sm-6 col-md-4">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onClick()">
                    {{ 'general.finalize'|translate }}
                </button>
            </div>
        </div>
    </div>
</main>
